var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon chevron",attrs:{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.35998 1.13694L4.45544 -2.05486e-07L11.2 7L4.45544 14L3.35999 12.8631L9.00908 7L3.35998 1.13694Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }